import * as services from '../../../services/graphql/widgets/parsely-my-local-news';
import { getLabel } from '../../../labels/labelling-service';

import widget from './widget';

export default {
  ...widget,
  modalPrivacyHtmlId: 'parselyModalPrivacy',
  isTagListActive: false,
  tagSelectDefaultText: getLabel('parsely.mylocalnews.tag.default.text'),
  tagSelectDefaultTextOpened: getLabel('parsely.mylocalnews.tag.default.text'),
  isCtaActive: true,
  loginCardText: getLabel('parsely.login.mylocalnews.card.text'),
  preferencesList: {
    messageSelect: [
      getLabel('parsely.mylocalnews.dropdown.message.select'),
      getLabel('parsely.mylocalnews.dropdown.message.deselect'),
    ],
  },
  styles: {
    setsOfCardsModifiers:
      'R4B bg-transparent-text-dark-m bg-transparent-text-dark-t bg-transparent-text-dark-d border-custom-d',
    cardModifiers: {
      rail: ['base', 'CA15-m', 'CA05C-t', 'CA05C-d'],
    },
    iconsColor: 'c-dark',
    sectionTitleColor: 'border',
    sectionTitleActiveColor: 'border',
    skeletonColor: 'light',
  },
  showLogo: false,
  services,
};
